// extracted by mini-css-extract-plugin
export var dropdown = "_g6-0";
export var imagePlaceholder = "_g6-2";
export var imageWrapper = "_g6-3";
export var productImage = "_g6-1";
export var truncateContainer = "_g6-4";
export var truncateText = "_g6-5";